import React, { useRef } from 'react';
import { TableComponents, SimpleDialog, PageContainer, ButtonLoading, TableItemActionsNew, Icons } from 'components';
import { Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { SelectClientDialog } from '../../../components';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../../../hooks';
import axios from 'axios';

import {
  getMyServiceCallApi,
  revokeApiKeyApi,
  confirmRequestApi,
  confirmRequestApiByGroup,
} from '../../../serviecs';
import { columns, columnsId } from '../../components/Columns';
import { constBreadCrumbsTitle } from 'utility';

const DetailRequestReceived = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();

  const tableRef = useRef();
  const {
    dialogContent,
    setDialogContent,
    openDialog,
    setOpenDialog,
    openDialogForm,
    setOpenDialogForm,
    selectedRow,
    setSelectedRow,
    dialogAction,
    setDialogAction,
    loadingAction,
    setLoadingAction,
    page, setPage,
    size, setSize,
    loading, setLoading
  } = useCustomHook();

  // GET Service List
  const getDataServiceList = async (query) => {
    let orderBy = [];
    const filter = [];
    setLoading(true);

    if (query?.filters.length) {
      query.filters.forEach((row) => {
        if (row.column.field === 'status' && row.value === 'all') {
          return;
        }
        filter.push({
          id: columnsId[row.column.field],
          value: row.value,
        });
      });
    }

    if (query?.orderBy) {
      const desc = query.orderDirection === 'desc';
      if (query?.orderBy.field === 'dateTime') {
        orderBy = [
          {
            columnNumber: 2,
            desc,
          },
          {
            columnNumber: 3,
            desc,
          },
        ];
      } else {
        orderBy = [
          {
            columnNumber: 5,
            desc,
          },
        ];
      }
    }

    const params = {
      page: query ? query?.pageNumber : page,
      size: query?.pageSize || size,
      id: invoiceId,
    };

    const data = {
      filterVOS: [...filter],
      parentParams: [],
      orderByElementVOS: orderBy ?? [],
    };

    try {
      const res = await getMyServiceCallApi(data, params);
      let resData = [];
      if (res.result.rows) {
        resData = res.result.rows.map((row, key) => ({
          num: query?.page * query?.pageSize + key + 1,
          requestedId: row.cols[0],
          serviceName: row.cols[1],
          dateTime: row.cols[2],
          receiverService: row.cols[3],
          serviceId: row.cols[4],
          status: row.cols[5],
          businessId: row.cols[6],
          clientId: row.cols[7],
          totalCall: row.cols[8],
        }));
      }
      setLoading(false);
      return {
        data: resData,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const methodWithConfirm = {};

  const confirmRequestWithSetClientId = (data) => {
    setSelectedRow((prev) => ({ ...prev, clientId: data.scClientId.client_id }));

    confirmRequest(selectedRow, data.scClientId.client_id);
  };

  const confirmRequest = async (rowData, setClientId = '') => {
    if (!setClientId && !rowData?.clientId) {
      setSelectedRow(rowData);
      setOpenDialogForm(true);
      return;
    }

    let data = {};

    if (Array.isArray(rowData)) {
      const ids = [];
      const clientIds = [];
      const srcBusinessIds = [];

      rowData.forEach((request) => {
        ids.push(request.requestedId);
        clientIds.push(request.clientId || setClientId);
        srcBusinessIds.push(request.businessId);
      });

      data = {
        id: ids,
        clientId: clientIds,
        srcBusinessId: srcBusinessIds,
      };
    } else {
      data = {
        id: rowData.requestedId,
        clientId: setClientId || rowData.clientId,
        productId: rowData.serviceId,
        srcBusinessId: rowData.businessId,
      };
    }

    setLoadingAction(true);

    try {
      if (Array.isArray(rowData)) {
        await confirmRequestApiByGroup(data);
      } else {
        await confirmRequestApi(data);
      }

      setOpenDialogForm(false);

      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    } catch (e) {
    } finally {
      setLoadingAction(false);
    }
  };

  methodWithConfirm.revokeRequest = async (rowData, confirm = false) => {
    setDialogAction('revokeRequest');

    if (!confirm) {
      setDialogContent({
        content: `آیا از لغو درخواست سرویس "<b>${rowData.serviceName}</b>" که توسط سرویس گیرنده "<b>${rowData.receiverService}</b>" دریافت شده اطمینان دارید؟`,
        title: 'لغو درخواست',
      });
      setOpenDialog(true);
      setSelectedRow(rowData);
      return;
    }

    setLoadingAction(true);

    try {
      const params = {
        productId: selectedRow.serviceId,
      };
      await revokeApiKeyApi(params, selectedRow.requestedId);
      createToast('موفق', 'لغو درخواست سرویس با موفقیت انجام شد.', 'success');

      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)

      setSelectedRow({});
      setOpenDialog(false);
    } catch (error) {
    } finally {
      setLoadingAction(false);
    }
  };

  const ActionsBtn = () => {
    return (
      <>
        <ButtonLoading
          onClick={() => methodWithConfirm[dialogAction]('', true)}
          loading={loadingAction}
          variant="contained"
          color="primary"
          name="تایید"
        />
        <Button variant="contained" onClick={closeDialog}>
          بستن
        </Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
    setOpenDialogForm(false);
  };

  return (
    <>
      <PageContainer
        title="لیست جزییات درخواست‌ دریافتی"
        breadcrumbs={constBreadCrumbsTitle.RECEIVED_REQUEST_WEBSERVICE_DETAIL}
        meta={
          <Button
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
            onClick={() => navigate(-1)}
            variant="outlined"
            color="primary"
          >
            بازگشت
          </Button>
        }
      >


        <TableComponents
          data={getDataServiceList}
          columns={columns(confirmRequest, methodWithConfirm.revokeRequest)}
          ref={tableRef}
          isLoading={loading}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getDataServiceList(ps)
          }}
        />
      </PageContainer>

      <SimpleDialog
        title={dialogContent.title}
        content={dialogContent.content}
        open={openDialog}
        actions={<ActionsBtn />}
      />

      <SelectClientDialog
        open={openDialogForm}
        loading={loadingAction}
        closeDialogForm={closeDialog}
        confirm={confirmRequestWithSetClientId}
      />
    </>
  );
};

export default DetailRequestReceived;
